import { render, staticRenderFns } from "./ProductBrandEdit.vue?vue&type=template&id=3807f311&scoped=true&"
import script from "./ProductBrandEdit.vue?vue&type=script&lang=js&"
export * from "./ProductBrandEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807f311",
  null
  
)

export default component.exports